const generateQuestionName = (type) => {
  return `${type.toLowerCase()}_${new Date().getTime()}`;
};

export {
  generateQuestionName,
};
